/* VH My Account (sections/vh-account-dashboard.liquid). Behavior ported from sections/account-dashboard.liquid's script.
   The only network calls are the same as the old section's Quick Reorder: POST /cart/add.js and GET /cart.js. */
(function () {
  var root = document.getElementById('vh-acct');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var L = function (k, d) { return root.dataset['i18n' + k] || d; };
  var toast = function (m) { if (window.VHK) VHK.toast(m); };
  var settle = function () { if (window.ScrollTrigger) setTimeout(function () { (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh()); }, 600); };

  /* ---------- dark / light (same localStorage key as the old section; only an explicit tap is saved) ---------- */
  var KEY = 'vhg-dashboard-theme', saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  var osDark = window.matchMedia('(prefers-color-scheme: dark)');
  var applyTheme = function (t) { root.setAttribute('data-theme', t); var b = $('#darkModeToggle'); if (b) b.setAttribute('aria-pressed', t === 'dark'); };
  applyTheme(saved || (osDark.matches ? 'dark' : 'light'));
  if (osDark.addEventListener) osDark.addEventListener('change', function (e) { if (!saved) applyTheme(e.matches ? 'dark' : 'light'); });
  var flip = function () { var t = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark'; applyTheme(t); saved = t; try { localStorage.setItem(KEY, t); } catch (e) {} };
  ['#darkModeToggle', '#mobileThemeToggle'].forEach(function (s) { var b = $(s); if (b) b.addEventListener('click', flip); });

  /* ---------- accordion cards: one open at a time; a click outside closes them (old L4344-4370) ---------- */
  var closeAll = function () { $$('.acc').forEach(function (c) { c.classList.remove('active'); c.querySelector('.action-mega-trigger').setAttribute('aria-expanded', 'false'); }); };
  $$('.acc .action-mega-trigger').forEach(function (t) {
    t.addEventListener('click', function () {
      var card = t.closest('.acc'), was = card.classList.contains('active');
      closeAll();
      if (!was) { card.classList.add('active'); t.setAttribute('aria-expanded', 'true'); }
      settle();
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#vh-acct .acc') && !e.target.closest('#vh-acct [data-open]') && $$('.acc.active').length) { closeAll(); settle(); }
  });
  $$('[data-open="orders"]').forEach(function (a) {
    a.addEventListener('click', function () { var c = $('.acc.orders'); if (c && !c.classList.contains('active')) c.querySelector('.action-mega-trigger').click(); });
  });

  /* ---------- order rows: one expanded at a time (old L4451-4467) ---------- */
  $$('.order-summary-trigger').forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.stopPropagation();
      var it = t.closest('.o'), was = it.classList.contains('expanded');
      $$('.o').forEach(function (o) { o.classList.remove('expanded'); o.querySelector('.order-summary-trigger').setAttribute('aria-expanded', 'false'); o.querySelector('.details-text').textContent = L('ViewDetails', 'View Details'); });
      if (!was) { it.classList.add('expanded'); t.setAttribute('aria-expanded', 'true'); it.querySelector('.details-text').textContent = L('HideDetails', 'Hide Details'); }
      settle();
    });
  });
  /* tracking number: copy on tap ("Click to copy" did nothing on the old page) */
  $$('[data-tracking]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation(); var t = b.getAttribute('data-tracking');
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { toast(L('TrackingCopied', 'Tracking number copied.')); }, function () { toast(L('TrackingNumber', 'Tracking number: __N__').replace('__N__', t)); });
    });
  });

  /* ---------- address: Show appears only when the one-line summary is cut off (old L3968-4009) ---------- */
  $$('[data-address-collapsible]').forEach(function (w) {
    var s = w.querySelector('[data-address-summary]'), b = w.querySelector('[data-address-toggle]'), f = w.querySelector('[data-address-full]');
    var check = function () { if (w.classList.contains('is-expanded')) return; b.hidden = !(s.scrollWidth > s.clientWidth + 1); };
    check(); var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(check, 150); });
    b.addEventListener('click', function () { var x = !w.classList.contains('is-expanded'); w.classList.toggle('is-expanded', x); b.setAttribute('aria-expanded', x); b.textContent = x ? L('Hide', 'Hide') : L('Show', 'Show'); f.hidden = !x; });
  });

  /* ---------- Quick Reorder: copied from the old section (L4014-4136); only the spinner's hidden flag is new ---------- */
  (function initQuickAdd() {
    var dashboard = root;
    const reorderCards = dashboard.querySelectorAll('.reorder-product-card');
    if (!reorderCards.length) return;

    reorderCards.forEach(card => {
      const minusBtn = card.querySelector('.qty-minus');
      const plusBtn = card.querySelector('.qty-plus');
      const qtyInput = card.querySelector('.qty-input');
      const addBtn = card.querySelector('.quick-add-btn');

      if (!minusBtn || !plusBtn || !qtyInput || !addBtn) return;
      const spin = addBtn.querySelector('.btn-loading');

      // Quantity controls
      minusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal < 99) {
          qtyInput.value = currentVal + 1;
        }
      });

      qtyInput.addEventListener('change', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val < 1) val = 1;
        if (val > 99) val = 99;
        qtyInput.value = val;
      });

      // Quick add to cart
      addBtn.addEventListener('click', async () => {
        const variantId = addBtn.dataset.variantId;
        const quantity = parseInt(qtyInput.value) || 1;

        if (!variantId) return;

        addBtn.classList.add('adding');
        if (spin) spin.hidden = false;
        const btnText = addBtn.querySelector('.btn-text');
        const originalText = btnText.textContent;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });

          if (response.ok) {
            addBtn.classList.remove('adding');
            if (spin) spin.hidden = true;
            addBtn.classList.add('added');
            btnText.textContent = L('Added', 'Added!');

            // Fetch updated cart and update all cart count elements
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            // Update cart count elements (multiple selectors for different themes)
            const cartCountSelectors = [
              '.cart-count-bubble span',
              '.cart-count-bubble',
              '[data-total-cart-item]',
              '[data-cart-count]',
              '.cart-count',
              '.header-cart-count'
            ];

            cartCountSelectors.forEach(selector => {
              document.querySelectorAll(selector).forEach(el => {
                if (el.tagName === 'SPAN' || el.hasAttribute('data-total-cart-item')) {
                  el.textContent = cartData.item_count;
                } else if (el.classList.contains('cart-count-bubble')) {
                  const span = el.querySelector('span');
                  if (span) span.textContent = cartData.item_count;
                }
              });
            });

            // Show cart count bubble if it was hidden (cart was empty)
            document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
              if (cartData.item_count > 0) {
                bubble.style.display = '';
                bubble.removeAttribute('hidden');
              }
            });

            // Trigger theme's pub/sub cart update if available
            if (typeof theme !== 'undefined' && theme.pubsub && theme.pubsub.publish) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'quick-reorder',
                productVariantId: variantId,
                cartData: cartData
              });
            }

            // Reset button after 2 seconds
            setTimeout(() => {
              addBtn.classList.remove('added');
              btnText.textContent = originalText;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          addBtn.classList.remove('adding');
          if (spin) spin.hidden = true;
          btnText.textContent = L('Error', 'Error');
          setTimeout(() => {
            btnText.textContent = originalText;
          }, 2000);
        }
      });
    });
  })();

  /* ---------- "Your path": counts and the upgrade's contents, read from the products' own descriptions ---------- */
  var itemsOf = function (txt) {
    txt = String(txt || '');
    var tot = txt.match(/(?:Total Products|Quantity of Products)\s*:\s*(\d+)/i);
    var list = {}, sum = 0, m, body = txt.split(/Total Products|Quantity of Products|Individual Products|FDA Disclaimer|Disclaimer:/i)[0];
    var start = body.search(/\(\d+\)/);
    if (start >= 0) {
      var re = /\((\d+)\)\s*([^,(]+?)\s*(?=,|\(|$)/g, seg = body.slice(start);
      while ((m = re.exec(seg))) { var n = m[2].replace(/\s+$/, '').trim(); if (n) { list[n] = (list[n] || 0) + (+m[1]); sum += +m[1]; } }
    }
    return {total: tot ? +tot[1] : sum, list: list};
  };
  $$('[data-items-of][data-desc]').forEach(function (el) { var r = itemsOf(el.getAttribute('data-desc')); if (r.total) el.textContent = r.total; });
  /* the copy line ("from 12 to 99 products") reuses the counts from the track */
  ['p0', 'p3'].forEach(function (k) { var src = $('.st [data-items-of="' + k + '"]'), dst = $('.pa-copy [data-items-of="' + k + '"]'); if (src && dst && /\d/.test(src.textContent)) dst.textContent = src.textContent; });
  var inc = $('#vaInc');
  if (inc) {
    var up = itemsOf(inc.getAttribute('data-desc')), thumbs = {};
    try { thumbs = JSON.parse(($('#vaThumbs') || {}).textContent || '{}'); } catch (e) {}
    /* names in pack descriptions vary ("SMART BIOTICS" / "SMARTBIOTICS"): match ignoring spaces, hyphens and case */
    var vhKey = function (s) { return String(s).toUpperCase().replace(/[^A-Z0-9+]/g, ''); };
    Object.keys(thumbs).forEach(function (k) { var nk = vhKey(k); if (!thumbs[nk]) thumbs[nk] = thumbs[k]; });
    var entries = Object.keys(up.list).map(function (k) { return [k, up.list[k]]; }).sort(function (a, b) { return b[1] - a[1]; });
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };
    inc.innerHTML = entries.map(function (e) {
      var t = thumbs[vhKey(e[0])] || null, name = t ? t[0] : e[0], img = t && t[1];
      return '<div class="ic"><div class="im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="ph">' + L('NoPhoto', 'No photo') + '</span>') + '</div><span>' + esc(name) + '</span><em>×' + e[1] + '</em></div>';
    }).join('');
    $$('[data-up-count]').forEach(function (el) { el.textContent = up.total; });
    var sumEl = $('[data-inc-sum]'); if (sumEl) sumEl.textContent = L('IncSum', '__N__ products, __T__ in total').replace('__N__', entries.length).replace('__T__', up.total);
    var mb = $('.inc-more');
    if (mb && entries.length > 9) {
      mb.hidden = false; mb.textContent = L('ShowAll', 'Show all __N__ products').replace('__N__', entries.length);
      mb.addEventListener('click', function () { var all = inc.classList.toggle('all'); mb.setAttribute('aria-expanded', all); mb.textContent = all ? L('ShowFewer', 'Show fewer') : L('ShowAll', 'Show all __N__ products').replace('__N__', entries.length); settle(); });
    }
  }

  /* ---------- member card: engraved lines, pointer tilt + foil, one glint ---------- */
  (function () {
    var g = $('#vaGuil'); if (!g) return;
    var d = '';
    for (var i = 0; i < 26; i++) {
      var y0 = 20 + i * 11, a = 10 + (i % 5) * 3, p = 'M0 ' + y0;
      for (var x = 0; x <= 460; x += 20) p += ' L' + x + ' ' + (y0 + Math.sin(x / 46 + i * .5) * a).toFixed(1);
      d += '<path d="' + p + '"/>';
    }
    g.innerHTML = '<g fill="none" stroke="rgba(255,255,255,.09)" stroke-width="1">' + d + '</g>';
  })();
  var card = $('#mc');
  var glint = function () { if (!card || RM) return; card.classList.remove('glint'); void card.offsetWidth; card.classList.add('glint'); };
  if (card) {
    card.addEventListener('animationend', function () { card.classList.remove('glint'); });
    if (!RM && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height, st = card.style;
        card.classList.add('live');
        st.setProperty('--ry', ((x - .5) * 14).toFixed(2) + 'deg'); st.setProperty('--rx', ((.5 - y) * 10).toFixed(2) + 'deg');
        st.setProperty('--mx', (x * 100).toFixed(1) + '%'); st.setProperty('--my', (y * 100).toFixed(1) + '%'); st.setProperty('--sh', '.7');
        st.setProperty('--hx', (x * 100).toFixed(1) + '%'); st.setProperty('--hy', (y * 100).toFixed(1) + '%'); st.setProperty('--holo', '.26');
        st.setProperty('--gx', ((x - .5) * -24).toFixed(1) + 'px'); st.setProperty('--gy', ((y - .5) * -24).toFixed(1) + 'px');
      });
      card.addEventListener('pointerleave', function () { card.classList.remove('live'); ['--rx', '--ry', '--mx', '--my', '--sh', '--hx', '--hy', '--holo', '--gx', '--gy'].forEach(function (p) { card.style.removeProperty(p); }); });
    }
    card.addEventListener('click', function () {
      glint();
      if (window.gsap && !RM && !window.matchMedia('(hover:hover)').matches) gsap.fromTo(card, {rotateY: -12}, {rotateY: 0, duration: 1.1, ease: 'elastic.out(1,.5)', clearProps: 'transform'});
    });
  }

  /* ---------- phone nav: highlight the section in view ---------- */
  var navs = $$('.va-nav a');
  if (navs.length) window.addEventListener('scroll', function () {
    if (!navs[0].offsetParent) return;
    var on = 0; ['#va-home', '#va-orders', '#va-profile'].forEach(function (s, i) { var el = $(s); if (el && el.getBoundingClientRect().top < innerHeight * .4) on = i; });
    navs.forEach(function (a, i) { a.classList.toggle('is-on', i === on); });
  }, {passive: true});

  /* ---------- name split for the entrance ---------- */
  var nm = $('[data-split]');
  if (nm && !RM) {
    var words = nm.textContent.trim().split(/\s+/);
    nm.innerHTML = words.map(function (w) { return '<span class="w">' + Array.from(w).map(function (c) { return '<span class="c">' + c.replace(/[&<>]/g, '') + '</span>'; }).join('') + '</span>'; }).join(' ');
  }

  /* ---------- motion (GSAP from cdnjs via vh-kit; the page is complete without it) ---------- */
  var start = function () {
    if (!window.VHK) { setTimeout(start, 50); return; }
    VHK.withGsap(function (ok) {
      if (!ok) return;
      $$('[data-count]').forEach(function (el) {
        var n = +el.getAttribute('data-count'), fmt = el.hasAttribute('data-fmt'), o = {v: 0}, end = el.textContent;
        gsap.to(o, {v: n, duration: 1.1, ease: 'power2.out', onUpdate: function () { el.textContent = fmt ? Math.round(o.v).toLocaleString('en-US') : Math.round(o.v); }, onComplete: function () { el.textContent = fmt ? n.toLocaleString('en-US') : end; }});
      });
      var amt = $('.loyalty-amount'), cents = amt ? +amt.getAttribute('data-cents') : 0;
      if (amt && cents) {
        var fin = amt.textContent, o2 = {v: 0};
        gsap.to(o2, {v: cents / 100, duration: 1.4, ease: 'power3.out', delay: .2, onUpdate: function () { amt.textContent = '$' + o2.v.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}); }, onComplete: function () { amt.textContent = fin; }});
      }
      var fg = $('#ringFg');
      if (fg) gsap.fromTo(fg, {attr: {'stroke-dashoffset': 414.69}}, {attr: {'stroke-dashoffset': 414.69 * (1 - (+fg.getAttribute('data-p') || 0))}, duration: 1.4, ease: 'power3.out', delay: .2});
      var tl = gsap.timeline({delay: .1, defaults: {ease: 'power3.out'}});
      tl.from(['#vh-acct .va-status', '#vh-acct h1 .g', '#vh-acct .lo > *'], {autoAlpha: 0, y: 26, duration: .9, stagger: .07})
        .from('#vh-acct h1 .n .c', {yPercent: 110, duration: 1, stagger: .028, ease: 'expo.out'}, .15)
        .from(['.va-desc', '.va-acts'], {autoAlpha: 0, y: 26, duration: .9, stagger: .07}, .45);
      if (card) tl.from(card, {autoAlpha: 0, y: 60, rotateX: 18, rotateY: -14, duration: 1.3, ease: 'expo.out', clearProps: 'transform,opacity,visibility'}, .15).add(glint, 1.05);
      if ($('.va-bo-wrap')) tl.from('#vh-acct .va-bo-wrap', {autoAlpha: 0, y: 16, duration: .7}, .55);
      tl.from(['#vh-acct .va-ledger', '#vh-acct .va-main'], {autoAlpha: 0, y: 30, duration: 1, stagger: .1}, .4);
      var path = $('#vaPath');
      if (path) {
        var sts = $$('.st, .pa-vis > img, .eqc', path), fillEl = $('#paFill');
        if (sts.length) gsap.fromTo(sts, {y: 50, autoAlpha: 0}, {y: 0, autoAlpha: 1, duration: .9, stagger: .1, ease: 'power3.out', scrollTrigger: {trigger: path, start: 'top 80%', once: true}});
        if (fillEl) gsap.fromTo(fillEl, {width: '0%'}, {width: fillEl.style.getPropertyValue('--fill'), duration: 1.4, ease: 'power2.inOut', delay: .3, scrollTrigger: {trigger: path, start: 'top 80%', once: true}});
        var ics = $$('.ic', path);
        if (ics.length) gsap.fromTo(ics, {autoAlpha: 0, y: 20}, {autoAlpha: 1, y: 0, duration: .5, stagger: .025, ease: 'power2.out', scrollTrigger: {trigger: '#vaInc', start: 'top 88%', once: true}});
      }
      VHK.reveals(root);
    });
  };
  start();
})();
